var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 538.141,
    height: 169.373,
    viewBox: "0 0 538.141 169.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 538.141,
    height: 169.373,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_home",
    transform: "translate(-787 -486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(787 486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,79.783,180.119,136.6,84.852,59.61Z",
    transform: "translate(0 32.772)",
    fill: "#34b2b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M0,105.844,82.762,86.168,92.622,0Z",
    transform: "translate(0 0)",
    fill: "#c9e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M67.516.721,57.608,87.269l95.185,76.945Z",
    transform: "translate(31.672 0.396)",
    fill: "#9bd4d3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo_home-2",
    "data-name": "logo_home",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M223.084,47.094c0-7.7,5.5-12.888,12.35-12.888a11.49,11.49,0,0,1,9.186,4.245l-1.564,1.178a9.879,9.879,0,0,0-7.622-3.479c-5.7,0-10.146,4.451-10.146,10.945,0,6.421,4.446,10.971,10.146,10.971a10.118,10.118,0,0,0,7.162-3.017V49.064H233.39V47.172H244.7v8.7a12.246,12.246,0,0,1-9.262,4.136c-6.853,0-12.35-5.213-12.35-12.911",
    transform: "translate(122.648 18.806)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M260.148,36.744l-5.781,14.577H265.9ZM269,59.379l-2.4-6.112H253.676l-2.4,6.112h-2.43l10-24.91h2.585l9.971,24.91Z",
    transform: "translate(136.809 18.95)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M264.947,59.379V57.51l14.7-21.1h-14.7V34.469h17.334v1.816l-14.7,21.15h14.932v1.943Z",
    transform: "translate(145.664 18.951)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 2.071,
    height: 24.91,
    transform: "translate(433.062 53.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M302.136,59.379,286.771,37.972V59.379H284.7V34.469h2.125l15.289,21.1v-21.1h2.074v24.91Z",
    transform: "translate(156.522 18.951)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M300.605,47.094c0-7.7,5.472-12.888,12.35-12.888a11.48,11.48,0,0,1,9.184,4.245l-1.562,1.178a9.839,9.839,0,0,0-7.622-3.479c-5.7,0-10.153,4.451-10.153,10.945,0,6.421,4.45,10.971,10.153,10.971a10.252,10.252,0,0,0,7.188-3.017V49.064h-9.232V47.172h11.3v8.7a12.183,12.183,0,0,1-9.255,4.136c-6.878,0-12.35-5.213-12.35-12.911",
    transform: "translate(165.268 18.806)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M242.251,57.435V34.47h-2.122V59.378h10.818l.793-1.943Z",
    transform: "translate(132.019 18.951)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M224.074,77.865l1.331-1.581a10.09,10.09,0,0,0,7.644,3.6c4.989,0,6.421-2.841,6.421-4.961,0-7.315-14.653-3.5-14.653-12.2,0-4.093,3.6-6.675,8.029-6.675a10.334,10.334,0,0,1,8.26,3.527l-1.382,1.562A8.671,8.671,0,0,0,232.716,58c-3.245,0-5.7,1.917-5.7,4.6,0,6.391,14.627,2.862,14.627,12.174,0,3.222-2.074,7.058-8.673,7.058a11.076,11.076,0,0,1-8.9-3.966",
    transform: "translate(123.192 30.817)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M259.572,68.941c0-6.289-3.811-10.945-9.664-10.945-5.885,0-9.638,4.656-9.638,10.945s3.754,10.946,9.638,10.946c5.854,0,9.664-4.654,9.664-10.946m-21.506,0c0-7.264,4.68-12.888,11.842-12.888,7.134,0,11.868,5.624,11.868,12.888,0,7.29-4.735,12.89-11.868,12.89-7.161,0-11.842-5.6-11.842-12.89",
    transform: "translate(130.885 30.817)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M256.367,81.25V56.318h2.118V79.308H270.3V81.25Z",
    transform: "translate(140.947 30.963)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M267.438,71.685V56.319h2.12V71.636c0,5.062,2.582,8.105,7.392,8.105,4.786,0,7.391-3.044,7.391-8.105V56.319h2.125V71.685c0,6.163-3.227,10-9.516,10-6.263,0-9.513-3.888-9.513-10",
    transform: "translate(147.033 30.963)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M290.483,81.25V58.259H282.5v-1.94h18.052v1.94H292.6V81.25Z",
    transform: "translate(155.316 30.963)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 2.071,
    height: 24.931,
    transform: "translate(460.222 87.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M323.135,68.941c0-6.289-3.811-10.945-9.668-10.945-5.881,0-9.641,4.656-9.641,10.945s3.76,10.946,9.641,10.946c5.857,0,9.668-4.654,9.668-10.946m-21.506,0c0-7.264,4.68-12.888,11.839-12.888,7.134,0,11.871,5.624,11.871,12.888,0,7.29-4.738,12.89-11.871,12.89-7.159,0-11.839-5.6-11.839-12.89",
    transform: "translate(165.831 30.817)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M337.7,81.25,322.331,59.844V81.25h-2.074V56.318h2.125L337.674,77.44V56.318h2.074V81.25Z",
    transform: "translate(176.073 30.963)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M335.885,77.865l1.356-1.581a10.082,10.082,0,0,0,7.643,3.6c4.961,0,6.4-2.841,6.4-4.961,0-7.315-14.633-3.5-14.633-12.2,0-4.093,3.585-6.675,8.006-6.675a10.266,10.266,0,0,1,8.263,3.527l-1.386,1.562A8.652,8.652,0,0,0,344.555,58c-3.248,0-5.7,1.917-5.7,4.6,0,6.391,14.627,2.862,14.627,12.174,0,3.222-2.1,7.058-8.669,7.058a11.174,11.174,0,0,1-8.924-3.966",
    transform: "translate(184.664 30.817)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M181.388,86.145l5.75-8.082a24.785,24.785,0,0,0,18.391,8.259c8.364,0,11.557-4.169,11.557-8.181,0-12.456-33.779-4.708-33.779-26.5,0-9.9,8.356-17.44,21.17-17.44,8.953,0,16.366,3.017,21.688,8.36l-5.754,7.726a23.437,23.437,0,0,0-16.9-6.828c-5.909,0-9.748,3.019-9.748,7.363,0,11.124,33.787,4.271,33.787,26.343,0,9.871-6.883,18.41-22.481,18.41-10.69,0-18.461-3.909-23.678-9.434",
    transform: "translate(99.724 18.806)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M151.774,34.833l-21,34.7V94.16h10.2V69.534l22.452-34.7Z",
    transform: "translate(71.9 19.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M141.519,56.621l-13.63-21.788H116.223l19.822,30.535Z",
    transform: "translate(63.898 19.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M193.448,43.989V34.833H153.631V94.16h39.817V85.005H163.84V68.46h16.872l5.807-9.153H163.84V43.989Z",
    transform: "translate(84.464 19.15)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHome);
export default __webpack_public_path__ + "static/media/logo_home.80ed401b1fdcc8f806dea658ef7bdf9e.svg";
export { ForwardRef as ReactComponent };